<template>
  <UiButton v-if="allowed" :variant="variant" :size="size" @click="open">
    {{ label || t('mailClient.record.send') }}
  </UiButton>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { UiButton } from '@general/ui-kit'
import { useAuthStore } from '@general/auth/frontend'

import { useMailCompose } from './store'

/**
 * «Enviar por email» on any record of the ERP: opens the platform's composer
 * with what the owning module prepares for that record (who, subject, the
 * PDF) and links the conversation to it.
 *
 * Shown only to whoever uses the mail client — the email goes out from their
 * own account. Whether they may send THIS record is the module's to say, on the
 * server, and the composer shows its answer.
 */
const props = defineProps({
  type: { type: String, required: true },
  referenceId: { type: String, required: true },
  label: { type: String, default: '' },
  variant: { type: String, default: 'secondary' },
  size: { type: String, default: 'md' },
  /** Anything else for the composer: subject, html, options, variants. */
  compose: { type: Object, default: () => ({}) },
})
const emit = defineEmits(['sent'])
const { t } = useI18n()
const auth = useAuthStore()
const { sendByEmail } = useMailCompose()

const allowed = computed(() => auth.can?.('mail:use') ?? false)

function open() {
  sendByEmail(props.type, props.referenceId, { ...props.compose, onSent: result => emit('sent', result) })
}
</script>
